export default "__VITE_ASSET__KfLEGeb5__"